// extracted by mini-css-extract-plugin
export var typingIndicator = "_io-0";